import React, { useState, useRef, useEffect } from 'react';

export default function StatusUnitDropdown({
  options = [],
  value = '',
  onChange,
  id = 'statusUnitCode',
  name = 'statusUnitCode',
  placeholder = 'Select',
  readOnly = false
}) {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter((option) => option.UNIT_CODE !== 6);
  const selectedOption = options.find(
    (option) => String(option.UNIT_CODE) === String(value)
  );

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleOptionSelect = (option) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: option ? option.UNIT_CODE : ''
        }
      });
    }
    closeDropdown();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeDropdown();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const displayText = selectedOption
    ? `${selectedOption.UNIT_CODE}-${selectedOption.UNIT_DESCRIPTION}`
    : value
    ? String(value)
    : '';

  if (readOnly) {
    return (
      <input
        type="text"
        className="form-control status-unit-dropdown__readonly"
        readOnly
        value={displayText}
        id={id}
        name={name}
        aria-labelledby={`${id}-label`}
      />
    );
  }

  return (
    <div
      className={`status-unit-dropdown ${isOpen ? 'open' : ''}`}
      ref={dropdownRef}
      id={`${id}-wrapper`}
    >
      <button
        type="button"
        className="form-select status-unit-dropdown__trigger"
        onClick={toggleDropdown}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-labelledby={`${id}-label`}
        id={id}
      >
        <span className="status-unit-dropdown__selected">
          {selectedOption
            ? `${selectedOption.UNIT_CODE}-${selectedOption.UNIT_DESCRIPTION}`
            : value
            ? String(value)
            : placeholder}
        </span>
        <span className="status-unit-dropdown__chevron">
          <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`} aria-hidden="true" />
        </span>
      </button>

      {isOpen && (
        <ul
          className="status-unit-dropdown__list"
          role="listbox"
          aria-activedescendant={selectedOption ? `${id}-${selectedOption.UNIT_CODE}` : undefined}
        >
          <li
            role="option"
            aria-selected={!selectedOption}
            className={`status-unit-dropdown__item ${!selectedOption ? 'selected' : ''}`}
            onClick={() => handleOptionSelect(null)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleOptionSelect(null);
              }
            }}
            tabIndex={0}
          >
            {placeholder}
          </li>
          {filteredOptions.map((option) => (
            <li
              key={option.UNIT_CODE}
              id={`${id}-${option.UNIT_CODE}`}
              role="option"
              aria-selected={String(option.UNIT_CODE) === String(value)}
              className={`status-unit-dropdown__item ${
                String(option.UNIT_CODE) === String(value) ? 'selected' : ''
              }`}
              onClick={() => handleOptionSelect(option)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleOptionSelect(option);
                }
              }}
              tabIndex={0}
            >
              <span className="status-unit-dropdown__item-code">{option.UNIT_CODE}</span>
              <span className="status-unit-dropdown__item-description">
                {option.UNIT_DESCRIPTION}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

